import React from "react";
import CustomModal from "../../../components/Modal/CustomModal";
import "./viewDnd.css"; // Import the CSS file

const ViewDND = ({ show, onHide, dndData }) => {
  return (
    <CustomModal show={show} onHide={onHide} title="View DND Details" size="lg">
      <div className="view-details-container">
        <div className="row mb-4">
          {/* <div className="col-md-6">
            <div className="detail-group">
              <label>ID</label>
              <span className="colon">:</span>
              <span className="value">{dndData?.id}</span>
            </div>
          </div> */}
          <div className="form-group col-md-6 mb-0">
            <div className="row mobile-line-row">
              {/* <label>MSISDN</label>
              <span className="colon">:</span> */}
              <div className="col-sm-6 label"><span>MSISDN</span><span>:</span></div>
              {/* <span className="value">{dndData?.msisdn}</span> */}
              <div className="col-sm-6 fw-bold text-wrap cont_div">{dndData?.msisdn}</div>
            </div>
          </div>
          <div className="form-group col-md-6 mb-0">
            <div className="row mobile-line-row">
              {/* <label>Date Time</label>
              <span className="colon">:</span> */}
                            <div className="col-sm-6 label"><span>Date Time</span><span>:</span></div>

              {/* <span className="value">{dndData?.dateTime}</span> */}
              <div className="col-sm-6 fw-bold text-wrap cont_div">{dndData?.dateTime}</div>

            </div>
          </div>
          <div className="form-group col-md-6 mb-0">
            <div className="row mobile-line-row">
              {/* <label>Created By</label>
              <span className="colon">:</span> */}
              <div className="col-sm-6 label"><span>Created By</span><span>:</span></div>

              {/* <span className="value">{dndData?.createdBy}</span> */}
              <div className="col-sm-6 fw-bold text-wrap cont_div">{dndData?.createdBy}</div>

            </div>
          </div>
          <div className="form-group col-md-6 mb-0">
            <div className="row mobile-line-row">
              {/* <label>Mobile Number</label>
              <span className="colon">:</span> */}
            <div className="col-sm-6 label"><span>Mobile Number</span><span>:</span></div>

              {/* <span className="value">{dndData?.mobileNo}</span> */}
              <div className="col-sm-6 fw-bold text-wrap cont_div">{dndData?.mobileNo}</div>

            </div>
          </div>
          <div className="form-group col-md-6 mb-0">
            <div className="row mobile-line-row">
              {/* <label>Country Code</label>
              <span className="colon">:</span> */}
                            <div className="col-sm-6 label"><span>Country Code</span><span>:</span></div>

              {/* <span className="value">{dndData?.countryCode}</span> */}
              <div className="col-sm-6 fw-bold text-wrap cont_div">{dndData?.countryCode}</div>

            </div>
          </div>
          <div className="form-group col-md-6 mb-0">
            <div className="row mobile-line-row">
              {/* <label>Operator Code</label>
              <span className="colon">:</span> */}
                            <div className="col-sm-6 label"><span>Operator Code</span><span>:</span></div>

              {/* <span className="value">{dndData?.operatorCode}</span> */}
              <div className="col-sm-6 fw-bold text-wrap cont_div">{dndData?.operatorCode}</div>

            </div>
          </div>
        </div>

        {/* <div className="row mb-4">

          <div className="form-group col-md-6">
            <div className="row mobile-line-row">
             
              <div className="col-sm-6 label"><span>Created By</span><span>:</span></div>

             
              <div className="col-sm-6 fw-bold text-wrap cont_div">{dndData?.createdBy}</div>

            </div>
          </div>
          <div className="form-group col-md-6">
            <div className="row mobile-line-row">
              
            <div className="col-sm-6 label"><span>Mobile Number</span><span>:</span></div>

            
              <div className="col-sm-6 fw-bold text-wrap cont_div">{dndData?.mobileNo}</div>

            </div>
          </div>
        </div> */}

        {/* <div className="row mb-4">

          <div className="form-group col-md-6">
            <div className="row mobile-line-row">
             
                            <div className="col-sm-6 label"><span>Country Code</span><span>:</span></div>

              <div className="col-sm-6 fw-bold text-wrap cont_div">{dndData?.countryCode}</div>

            </div>
          </div>
          <div className="form-group col-md-6">
            <div className="row mobile-line-row">
             
                            <div className="col-sm-6 label"><span>Operator Code</span><span>:</span></div>

              <div className="col-sm-6 fw-bold text-wrap cont_div">{dndData?.operatorCode}</div>

            </div>
          </div>
        </div> */}

        {/* <div className="row mb-4">
         
        </div> */}
      </div>

      <div className="modal-footer pb-0 border-0 d-flex justify-content-between px-0 mx-0">
        <div className="row w-100 mx-0 px-0">
          <div className="col-md-1 d-flex justify-content-start m-0 p-0 buttons_divs">
            <button type="button" className="btn btn-secondary" onClick={onHide}>
              Close
            </button>
          </div>
        </div>

      </div>
    </CustomModal>
  );
};

export default ViewDND;
